import { Route as ItemSalesVelocityRoute } from "@/routes/(inventory)/branch/_layout/reports/item-sales-velocity/index";
import { useQuery } from "@tanstack/react-query";
import { getItemSalesVelocity } from "../-data/api";
import { ItemSalesVelocityReportResponse } from "@/gen/reports/item_sales_velocity_report_pb";

interface ReportQueryResult {
  items: any[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const useItemSalesVelocityData = () => {
  const searchParams = ItemSalesVelocityRoute.useSearch();
  
  const page = searchParams.page || 1;
  const pageSize = searchParams.pageSize || 10;
  
  return useQuery<ReportQueryResult>({
    queryKey: ["item-sales-velocity", searchParams],
    queryFn: async () => {
      const response = await getItemSalesVelocity(page, pageSize);
      
      return {
        items: response.itemSalesVelocityItems,
        totalCount: response.totalCount,
        page,
        pageSize,
      };
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};